<template>
    <div class="container">
        <h1>Redefinir sua Senha!</h1>


        <b-card >

                <vue-form  @submit.prevent="recover" name="recoverform" v-model="clientInfo" class=''>

                    <div v-if="this.error" class='alert alert-danger'>
                        {{ this.error }}
                    </div>

                    <div class="row">
                        <vue-field class='col-12'  type="password"  name="password1" label="Senha" required ></vue-field>
                        <vue-field  class='col-12 ' type="password" name="password2" label="Confirme sua Senha" required ></vue-field>
                        
                        <div v-if="msg" class="alert alert-success">
                            <p>{{msg}}</p>
                            <p> <a href="/"> Voltar para o início </a></p>

                        </div>



                        <div class="col-12">
                            <input  class='btn btn-primary' type="submit" value="Redefinir">
                        </div>

                    </div>

                </vue-form>

        </b-card>


        
    </div>
</template>

<script>

import validadeFormMixins from "@/mixins/validateForms"
import api from "@/api"

export default {
    mixins:[validadeFormMixins],

    data(){
        return{
            clientInfo:{},
            error:false,
            edit:false,
            registerAnother:false,
            erromsg:'',
            mode:"login",
            msg:''
        }
    },

    created:{
    
    },
    
    computed:{
        user:function(){
            return this.$store.getters.user
        }
    },

    methods:{

        redirect:function(){
            let path = this.$route.query.redirect;
            if(!path) path="/";
            this.$router.replace(path);
        },


        recover:async function(){
            this.msg = ''
            var formValid = await this.validateForms();
            if(!formValid) return
            if(this.clientInfo.password1 != this.clientInfo.password2){
                this.error = "Senhas não conferem!"
                return;
            }
            let response = await this.$store.dispatch('setNewPassword', {password:this.clientInfo.password1, token:this.$route.params.access_token} )

            if(response){
                // this.redirect()
                this.msg = "Senha redefinida com sucesso."
            }
        },
        
    }

}
</script>